import { api } from "@/api"

export const retrieveSelfUser = async () => {
  const { body } =
    await api.get<UserAuthResponse>("/users/self/")
  return body
}
